import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginExt from "../login-ext/login-ext";
import Books from "../books/books";
import Manifestqueue from "../manifestqueue/manifestqueue";
import Cancelqueue from "../cancelqueue/cancelqueue";
import Reportsdownloadqueue from "../reportsdownloadqueue/reportsdownloadqueue";
import Verificationqueue from "../manifest_verificationqueue/verificationqueue";
import CuttingForm from "../cutting/cutting";
import ScanningForm from "../scanning/scanning";
import QC from "../qc/qc";
import Home from "../Home/home";
import SignInOidc from "../../components/signIn/signin-oidc";
import { useAuth } from "react-oidc-context";
import { useAuth as useAuthName } from "../../auth/AuthContext";
import RoleBasedRoute from "../../components/roleBasedRoute/RoleBasedRoute";
import SignOutOidc from "../../components/signout/signout-oidc";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import UserManagement from "../user-management/user-management";
import Activenewqueue from "../activequeuenew/activequeuenew";
import Reworkqueue from "../reworkqueue/reworkqueue";
import BooksEdit from "../books/books-edit";
import Error401Page from "../errorpages/401errorpage";
import Error404Page from "../errorpages/404errorpage";
import RecycleQueue from "../recycle/recycle";
import Clientqueue from "../clientqueue/clientqueue";
import BookDetailsReport from "../reports/bookdetailsreport";
import FullExtractReport from "../reports/fullextractreport";
import IdleReports from "../reports/idlereport";
import ProductivityReport from "../reports/productivityreport";
import QCReport from "../reports/qcreport";
import DeliveryToS3Queue from "../deliverytos3queue/deliverytos3queue";
import ManifesCreation from "../manifest-creation/manifestcreation";
import Exceptionqueue from "../exceptionqueue/exceptionqueue";
import ErrorAuthorization from "../errorpages/authorization-error";
import BookMasterReport from "../reports/activequeueexport";
import BulkRackUpdate from "../bulkrackupdate/bulkrack-update";
import ExceptionBookAction from "../exceptionaction/exception-action";
import QCPassedButNotDeliveredtoS3 from "../QCPassedButNotDeliveredtoS3/QCPassedButNotDeliveredtoS3";
import ClientSelfFixed from "../clientqueue/client-self-fixed";
import RecycleBidConfirmation from "../recycle/recyclebid-confirmation";
import ReadyTorecycleConfirmation from "../readytorecycle/readytorecycleconfirmation";
import ManifestRecycle from "../recycle/manifest-master";
import LoadTrackingQueue from "../recycle/loadtracking-queue";
import QCErrorCategory from "../qc/qc-error";
import LanguageMaster from "../language/lang";
import ExternalApiMaster from "../externalApi/externalApi";
import RejectReasonMaster from "../rejectReason/rejectReason";
import ExceptionLog from "../exceptionLog/exceptionLog";
import ChangeStatus from "../change-status/change-status";
import LegalBatchService from "../legalBatchService/legalBatchService";
import ProcessedISBN from "../legalBatchService/processedIsbn";
import BillingReport from "../reports/billingreport";
import RejectionReport from "../reports/RejectionReport";
import ClientFeedbackLog from "../VendorFeedback/ClientFeedbackLog";
import ProcessedFeedback from "../VendorFeedback/processesclientfeed";
import DeliverToS3Feedback from "../DeliveryToQueue/deliverytos3feedback";
import ProcessedDeliveryFeedback from "../DeliveryToQueue/deliveryfeed";
import LegalDataVerifierReport from "../reports/legaldataverifierreport";
import VendorMaster from "../vendormaster/vendor-master";
import StagnantBooksQueue from "../stagnantbooksqueue/stagnant-booksqueue";
import UserAuditQueue from "../userauditqueue/userauditqueue";
import FieldAccessControls from "../fieldRoleManagement/fieldRoleManagement";
import MrbQueue from "../MRB Queue/mrbQueue";
import QcAccessControls from "../qcskipmanagement/qcskipmanagement";
import UserRoleMaster from "../userrolemaster/userrolemaster";

const MainSection = () => {
    const auth = useAuth();
    const { isAuthenticated } = useAuthToken();
    const { userRoles, rolePagePermissions } = useAuthName();
    const routes = rolePagePermissions || [];

    const componentMap = {
        Home: Home,
        Books: Books,
        BooksEdit: BooksEdit,
        LoginExt: LoginExt,
        Manifestqueue: Manifestqueue,
        Cancelqueue: Cancelqueue,
        Reportsdownloadqueue: Reportsdownloadqueue,
        Verificationqueue: Verificationqueue,
        CuttingForm: CuttingForm,
        ScanningForm: ScanningForm,
        QC: QC,
        SignInOidc: SignInOidc,
        UserManagement: UserManagement,
        Activenewqueue: Activenewqueue,
        Reworkqueue: Reworkqueue,
        Error401Page: Error401Page,
        Error404Page: Error404Page,
        RecycleQueue: RecycleQueue,
        Clientqueue: Clientqueue,
        BookDetailsReport: BookDetailsReport,
        IdleReports: IdleReports,
        FullExtractReport: FullExtractReport,
        ProductivityReport: ProductivityReport,
        QCReport: QCReport,
        DeliveryToS3Queue: DeliveryToS3Queue,
        Exceptionqueue: Exceptionqueue,
        ErrorAuthorization: ErrorAuthorization,
        BookMasterReport: BookMasterReport,
        BulkRackUpdate: BulkRackUpdate,
        ManifesCreation: ManifesCreation,
        ExceptionBookAction: ExceptionBookAction,
        QCPassedButNotDeliveredtoS3: QCPassedButNotDeliveredtoS3,
        ClientSelfFixed: ClientSelfFixed,
        RecycleBidConfirmation: RecycleBidConfirmation,
        ReadyTorecycleConfirmation: ReadyTorecycleConfirmation,
        ManifestRecycle: ManifestRecycle,
        LoadTrackingQueue: LoadTrackingQueue,
        QCErrorCategory: QCErrorCategory,
        LanguageMaster: LanguageMaster,
        ExternalApiMaster: ExternalApiMaster,
        RejectReasonMaster: RejectReasonMaster,
        ExceptionLog: ExceptionLog,
        ChangeStatus: ChangeStatus,
        LegalBatchService: LegalBatchService,
        ProcessedISBN: ProcessedISBN,
        BillingReport: BillingReport,
        RejectionReport: RejectionReport,
        ClientFeedbackLog: ClientFeedbackLog,
        ProcessedFeedback: ProcessedFeedback,
        DeliverToS3Feedback: DeliverToS3Feedback,
        ProcessedDeliveryFeedback: ProcessedDeliveryFeedback,
        LegalDataVerifierReport: LegalDataVerifierReport,
        VendorMaster : VendorMaster,
        StagnantBooksQueue: StagnantBooksQueue,
        UserAuditQueue: UserAuditQueue,
        FieldAccessControls: FieldAccessControls,
        MrbQueue: MrbQueue,
        QcAccessControls: QcAccessControls,
        UserRoleMaster: UserRoleMaster,
    };


    function isSubset(subsetArray, supersetArray) {
        return subsetArray.some(element => supersetArray.includes(element));
    }
    const isroleNames = (isAuthenticated && Array.isArray(userRoles) && userRoles?.length > 0) ? userRoles[0]?.roleName?.split(",") : [];


    if (auth.isLoading) return <div>Loading...</div>;
    //if (auth.error) return <div>Error: {auth.error.message}</div>;
    if (auth.error) console.log(auth.error.message);

    return (
        <Routes>
            {/* Protected routes - require authentication */}
            {isAuthenticated ? (
                <>
                    <Route path="/home" element={<Home />} />

                    {routes.map((route, index) => {
                        const Component = componentMap[route.elementName];
                        const allowdRoles = isSubset(isroleNames, route.allowedRoles);
                        if (allowdRoles) {
                            return (
                                //(index === (routes.length - 1)) && (<Route path="*" element={<Error404Page />} />)
                                <Route
                                    key={`${route.pathKey}-${index}`}
                                    path={route.pathKey}
                                    element={
                                        <RoleBasedRoute allowedRoles={route.allowedRoles}>
                                            <Component />
                                        </RoleBasedRoute>
                                    }
                                />
                            );
                        }

                    })}
                </>
            ) : (
                <Route path="*" element={<Error404Page />} />
            )}
            {/* Public routes - require no authentication */}
            <Route path="/" element={<LoginExt />} />
            <Route path="/signin-oidc" element={<SignInOidc />} />
            <Route path="/signedout-oidc" element={<SignOutOidc />} />
            <Route path="/unauthorized" element={<Error401Page />} />
            {/* <Route path="*" element={<Error404Page />} /> */}
            <Route path="/failed-authorization" element={<ErrorAuthorization />} />
        </Routes>
    );
};

export default MainSection;